import { ApolloClient } from 'apollo-client'
import { split, ApolloLink } from 'apollo-link'
import { setContext } from 'apollo-link-context'
import { HttpLink } from 'apollo-link-http'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { onError } from '@apollo/client/link/error'
import fetch from 'node-fetch'

const withToken = setContext(async () => {
  await window.bmTerminalApp.$store.dispatch("getTerminalToken")
  const token = window.localStorage.getItem('BMterminalToken')
  return { token }
})

const authLink = new ApolloLink((operation, forward) => {
  const { token } = operation?.getContext() || { token: null }
  operation.setContext(() => ({
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  }))

  return forward(operation)
})

const httpLink = ApolloLink.from([withToken, authLink.concat(new HttpLink({
  uri: `${process.env.VUE_APP_GRAPHQL_HTTP}`,
  options: { mode: 'no-cors' }
}))])

const subscriptionLink = process.browser ? new WebSocketLink({
  uri: `${process.env.VUE_APP_GRAPHQL_WS}`,
  options: {
    mode: 'no-cors',
    reconnect: true,
    lazy: true,
    connectionParams: async () => {
      await window.bmTerminalApp.$store.dispatch("getTerminalToken")
      const token = window.localStorage.getItem('BMterminalToken')
      return {
        Authorization: `Bearer ${token}` || null
      }
    }
  }
}) : null

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, ...rest }) => {
      /* eslint-disable-next-line no-console */
      console.log(`[GraphQL error]: ${message}`, rest)
    })
  }

  if (networkError) {
    /* eslint-disable-next-line no-console */
    console.log(`[Network error]: ${JSON.stringify(networkError)}`)
  }

  if (operation) {
    /* eslint-disable-next-line no-console */
    console.log(`[operation]: ${JSON.stringify(networkError)}`)
  }
})

export const subscriptionClient = subscriptionLink?.subscriptionClient || {}

const subLink = process.browser ? subscriptionLink : null

const link = process.browser ? split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  subLink,
  httpLink,
) : httpLink

const cache = new InMemoryCache({ resultCaching: false })

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore'
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  }
}

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([errorLink, link]),
  fetch: fetch,
  cache: cache,
  defaultOptions
})
